// theme.js
import {createSystem, defaultConfig, defineConfig} from '@chakra-ui/react';

const colors = {
    primary: {
        50: "#e0f2f4",
        100: "#b3dde0",
        200: "#80c6cb",
        300: "#4cafb6",
        400: "#269aa2",
        500: "#033642", // Custom Primary color
        600: "#022f3b",
        700: "#022734",
        800: "#011f2c",
        900: "#011724",
    },
    secondary: {
        50: "#f0f0f7",
        100: "#d6d8e1",
        200: "#bdbfd2",
        300: "#a4a7c2",
        400: "#8a8db2",
        500: "#73759d", // Secondary base color
        600: "#5a5c7a",
        700: "#444558",
        800: "#2f2f38",
        900: "#1a1a1e",
    },
    success: "#28a745",
    warning: "#ffc107",
    error: "#dc3545",
};

const customConfig = defineConfig({
    globalCss: {
        body: {
            colorPalette: "teal"
        }
    },
    theme: {
        tokens: {
            colors: colors
        },
        breakpoints: {
            tablet: "992px",
            desktop: "1200px",
            wide: "1400px",
        },
    }
});


const theme = createSystem(defaultConfig, customConfig);

export default theme;
